import script from "./ConsumerCategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerCategoryView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerCategoryView.vue?vue&type=style&index=0&id=2c08c90b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c08c90b"]])

export default __exports__